import { useRef, useState, useEffect } from 'react';

interface UseScrollAnimationReturn {
  ref: React.RefObject<HTMLDivElement>;
  visible: boolean;
}

export function useScrollAnimation(threshold = 0.12): UseScrollAnimationReturn {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { threshold }
    );

    observer.observe(el);
    return () => observer.disconnect();
  }, [threshold]);

  return { ref, visible };
}
